export type ReadonlySiteEndpoints = {
  readonly SaveSite: string;
  readonly GetSites: string;
  readonly GetSiteById: string;
  readonly UpdateSite: string;
  readonly DeleteSite: string;
  readonly CheckInactiveSite: string;
  readonly GetState : string;
  readonly GetCityById : string;
  readonly GetCity : string;
  readonly GetUserSites : string;
  readonly GetTasksRaisedCategory : string;
  readonly GetTasksRaisedBuilding : string;
  readonly ExpenditureReportCategory : string;
  readonly ExpenditureReportBuilding : string;
  readonly TaskDaysOpens : string;
  readonly GetExpCategoryBuildings : string;
  readonly GetBuilding : string;
  readonly GetBuildingBySiteIdNonCapex : string;
  readonly GetPrioritySiteData : string;
  readonly GetStatusSiteData : string;
  readonly GetActiveTaskByProgress : string;
  readonly GetActiveTaskByPriority : string;
  readonly GetWorkOrderReportByMonth : string;
  readonly GetPurchaseOrderReportByMonth : string;
  readonly GetJobsheetSubmittedPerMonth : string;
  readonly GetJobHoursPerTechnician : string;
  readonly GetExpenditureReportCategoryNonCapex : string;
  readonly GetExpenditureReportBuildingNonCapex : string;
  readonly GetExpenditureReportCategoryBuildingNonCapex : string;
  readonly GetTechnicianJobHoursData : string;
  readonly GetAllSiteData : string;
  readonly GetTechnicianJobsheetSubmittedPerMonth : string;
  readonly GetExpenditurerReportoFNonCapexAndUnscheduled:string;
  readonly GetExpenditurerReportoNonCapexAndScheduled:string;
  readonly GetExpenditureReportBuildingNonCapexNonRecurring:string;
  readonly GetExpenditureReportBuildingNonCapexRecurring:string;
  readonly GetExpenditureReportCategoryNonCapexRecuring:string;
  readonly GetDueTaskByOwner : string;
  readonly GetActiveTaskByProgressByOwner : string;
  readonly GetJobsheetHoursMaterialCostNonRecurringByCategory:string;
  readonly GetjobSheetHoursAndMaterialsRecurring:string;
  readonly GetJobSheetHoursByBuildingNonRecurring:string;
  readonly GetJobSheetHoursByBuildingRecurring:string;
  readonly GetJobSheetHoursByCategoryBuildingNonRecurring : string;
  readonly GetJobSheetHoursByCategoryBuildingRecurring: string;
  readonly GetMaterialsCostByCategoryRecurring : string;
  readonly GetMaterialsCostByCategoryNonRecurring : string ;
  readonly GetMaterialsCostByBuildingNonRecurring :string;
  readonly GetMaterialsCostByBuildingRecurring :string;
  readonly GetMaterialsCostByCategoryBuildingNonRecurring : string;
  readonly GetMaterialsCostByCategoryBuildingRecurring:string;
};

const controller = 'api/Sites'

const SiteEndpoints: ReadonlySiteEndpoints = {
  SaveSite: `${controller}/AddUpdateSite`,
  GetSites: `${controller}/GetSites`,
  GetSiteById: `${controller}/GetSiteById`,
  UpdateSite: `${controller}/AddUpdateSite`,
  DeleteSite: `${controller}/DeleteSite`,
  CheckInactiveSite: `${controller}/CheckActiveSite`,
  GetState : `api/State/GetState`,
  GetCityById : `api/City/GetCityById`,
  GetCity : `api/City/GetCity`,
  GetUserSites : `${controller}/GetUserSites`,
  GetTasksRaisedCategory :  `api/Dashboard/GetTaskReportCategory`,
  GetTasksRaisedBuilding : `api/Dashboard/GetTaskReportBuidling`,
  ExpenditureReportCategory : `api/Dashboard/GetExpenditureReportCategory`,
  ExpenditureReportBuilding : `api/Dashboard/GetExpenditureReportBuilding`,
  TaskDaysOpens: `api/Dashboard/GetDaysTaskOpen`,
  GetExpCategoryBuildings: `api/Dashboard/GetExpenditureReportCategoryBuilding`,
  GetBuilding : `api/Building/GetBuildingBySiteId`,
  GetBuildingBySiteIdNonCapex : `api/Building/GetBuildingBySiteIdNonCapex`,
  GetPrioritySiteData : `api/Users/GetPrioritySiteData`,
  GetStatusSiteData : `api/Users/GetStatusSiteData`,
  GetActiveTaskByProgress : `api/Dashboard/GetActiveTaskByProgress`,
  GetActiveTaskByPriority : `api/Dashboard/GetActiveTaskByPriority`,
  GetWorkOrderReportByMonth : `api/Dashboard/GetWorkOrderReportByMonth`,
  GetPurchaseOrderReportByMonth : `api/Dashboard/GetPurchaseOrderReportByMonth`,
  GetJobsheetSubmittedPerMonth : `api/Dashboard/GetJobsheetSubmittedPerMonth`,
  GetJobHoursPerTechnician : `api/Dashboard/GetJobHoursPerTechnician`,
  GetExpenditureReportCategoryNonCapex : `api/Dashboard/GetExpenditureReportCategoryNonCapex`,
  GetExpenditureReportCategoryNonCapexRecuring:`api/Dashboard/GetExpenditureReportCategoryNonCapexRecuring`,
  GetExpenditureReportBuildingNonCapex : `api/Dashboard/GetExpenditureReportBuildingNonCapex`,
  GetExpenditureReportCategoryBuildingNonCapex : `api/Dashboard/GetExpenditureReportCategoryBuildingNonCapex`,
  GetTechnicianJobHoursData : `api/TechnicianDasboard/GetTechnicianJobHoursData`,
  GetAllSiteData:`api/TechnicianDasboard/GetAllSiteData`,
  GetTechnicianJobsheetSubmittedPerMonth:`api/TechnicianDasboard/GetTechnicianJobsheetSubmittedPerMonth`,
  GetExpenditurerReportoFNonCapexAndUnscheduled:`api/Dashboard/GetExpenditurerReportoFNonCapexAndUnscheduled`,
  GetExpenditurerReportoNonCapexAndScheduled:`api/Dashboard/GetExpenditurerReportoNonCapexAndScheduled`,
  GetExpenditureReportBuildingNonCapexNonRecurring:`api/Dashboard/GetExpenditureReportBuildingNonCapexNonRecurring`,
  GetExpenditureReportBuildingNonCapexRecurring:`api/Dashboard/GetExpenditureReportBuildingNonCapexRecurring`,
  GetDueTaskByOwner: `api/Dashboard/GetDueTaskByOwner`,
  GetActiveTaskByProgressByOwner:  `api/Dashboard/GetActiveTaskProgressByOwner`,
  GetJobsheetHoursMaterialCostNonRecurringByCategory:`api/Dashboard/GetjobsheetHoursNonRecurringByCategory`,
  GetjobSheetHoursAndMaterialsRecurring:`api/Dashboard/GetjobsheetHoursRecurringByCategory`,
  GetJobSheetHoursByBuildingRecurring:`api/Dashboard/GetJobSheetHoursByBuildingRecurring`,
  GetJobSheetHoursByCategoryBuildingNonRecurring:`api/Dashboard/GetJobSheetHoursByCategoryBuildingNonRecurring`,
  GetJobSheetHoursByBuildingNonRecurring:`api/Dashboard/GetJobSheetHoursByBuildingNonRecurring`,
  GetJobSheetHoursByCategoryBuildingRecurring:`api/Dashboard/GetJobSheetHoursByCategoryBuildingRecurring`,
  GetMaterialsCostByCategoryRecurring:`api/Dashboard/GetMaterialsCostByCategoryRecurring`,
  GetMaterialsCostByCategoryNonRecurring:`api/Dashboard/GetMaterialsCostByCategoryNonRecurring`,
  GetMaterialsCostByBuildingNonRecurring:`api/Dashboard/GetMaterialsCostByBuildingNonRecurring`,
  GetMaterialsCostByBuildingRecurring:`api/Dashboard/GetMaterialsCostByBuildingRecurring`,
  GetMaterialsCostByCategoryBuildingNonRecurring:`api/Dashboard/GetMaterialsCostByCategoryBuildingNonRecurring`,
  GetMaterialsCostByCategoryBuildingRecurring:`api/Dashboard/GetMaterialsCostByCategoryBuildingRecurring`,



};

export { SiteEndpoints };


